
<template>
  <div v-loading="loading" element-loading-text="数据加载中" style="height: 90vh;">
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: true
      };
    },
    methods: {
      login: function(obj) {
        var form = {
          type: 1,
          sim: 1,
          loginDevice: 1,
          loginName: obj.loginName,
          password: obj.password
        };
        this.$axios.post('/j_spring_security_check', this.$qs.stringify(form), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.$router.push('/Learning');
          } else {
            this.$message.error(data.message);
          }
        })
      }
    },
    created: function() {
      // 获取用户信息
      var url = 'loginName=' + decodeURIComponent(this.$route.query.loginName);
      // return;
      // 获取参数
      var qs = url, // 获取url中"?"符后的字串
        args = {}, // 保存参数数据的对象
        items = qs.length ? qs.split("&") : [], // 取得每一个参数项,
        item = null,
        len = items.length;

      for (var i = 0; i < len; i++) {
        item = items[i].split("=");
        var name = decodeURIComponent(item[0]),
          value = decodeURIComponent(item[1]);
        if (name) {
          args[name] = value;
        };
      }
      this.login(args);
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/loadlogin.vue